import { createReducer, on } from '@ngrx/store';
import {
  ActiveComponentChanged,
  ResetStateFromRouter,
} from 'src/app/shared/actions/eliqua.actions';
import { CloseSidenav, OpenSidenav, UpdateUser } from '../actions/side-nav.actions';
import { SideNavState } from '../models/user.models';

const initialState: SideNavState = {
  sidenavStatus: false,
  updateUser: false,
};

export const SideNavReducer = createReducer(
  initialState,
  on(OpenSidenav, (state) => ({
    ...state,
    sidenavStatus: true,
  })),
  on(CloseSidenav, (state) => ({
    ...state,
    sidenavStatus: false,
    updateUser: false,
  })),
  on(UpdateUser, (state) => ({
    ...state,
    updateUser: true,
  })),
  on(ActiveComponentChanged, (state) => ({
    ...state,
    sidenavStatus: false,
    updateUser: false,
  })),
  on(ResetStateFromRouter, () => ({
    ...initialState,
  })),
);
